import { useFlow } from "@edreamsodigeo/frontend-core";
const MOBILE_FLOW = "mobile";
export const useDevice = () => {
  const flow = useFlow();
  const isMobile = flow === MOBILE_FLOW;
  return {
    isDesktop: !isMobile,
    isMobile
  };
};